import React, { useEffect, useRef, useState } from "react";
import Table from "../ui/Table";
import VirtualTable from "../ui/VirtualTable";
import { pubCall } from "../utils/PubSub";
import { showError, showMessage } from "../ui/Message";
import { SortIcon } from "../utils/Icons";
import { bm_date, drawPrice, istl, toPrice } from "../utils/Utils";
import customParseFormat from 'dayjs/plugin/customParseFormat';
import dayjs from "dayjs";
import Cookies from "js-cookie";
import ScrollWrap from "../ui/ScrollWrap";

export default function InventoryList(props) {

    const scrollRef = useRef();

    const {
        controller = "",
        signal = {},
        view = "",
        state = {},
        loading = false,
        setLoading = () => { },
        data = [],
        setData = () => { },
        selected = 0,
        setSelected = () => { },
        filters = { sort: "id", localSort: "id" },
        setFilters = () => { },
        route = "",
        align = "auto",
        setAlign = () => { },
        seachResults = {},
        isTitleLink = false,
        filterLocal = () => { },
        infinite = true,
        header = "",
        search = false
    } = props;


    const [block, setBlock] = useState((search) ? true : false); 

    const buffer = 80;

    //const min = (view === "inventory" || view === "orders") ? false : true;

    const min = (view === "history_full" || state.tabs === "orders" && state.history_checked) ? true : false;


    const toggleSort = (_key) => {
        if (filters.sort === _key) {
            setFilters({ ...filters, "sort": "id", "dynamic": true })
        } else {
            setFilters({ ...filters, "sort": _key, "dynamic": true })
        }
    }


    const toggleLocalSort = (_key) => {

        let _f = "stock_id";
        if (data.length > 0 && data[0].hasOwnProperty("init")) {
            _f = "init";
        }

        if (filters.localSort === _key) {
            setFilters({ ...filters, "localSort": [_f], "dynamic": false })
        } else {
            setFilters({ ...filters, "localSort": _key, "dynamic": false })
        }

    }


    const colSort = (_text, _key, _local_key) => {

        if (filters?.type === "keyword") {
            return (<>{_text}</>)
        }

        if (!filters.dynamic) {
            const match = (filters.localSort === _key);
            if (!match) {
                return (<div onClick={() => toggleLocalSort(_local_key)} className="ui-col-sort">{_text} &nbsp;<SortIcon />&nbsp;</div>)
            } else {
                return (<div onClick={() => toggleLocalSort(_local_key)} className="ui-col-sort active">{_text} &nbsp;<SortIcon />&nbsp;</div>)
            }
        }
        const match = (filters.sort === _key);
        if (!match) {
            return (<div onClick={() => toggleSort(_key)} className="ui-col-sort">{_text} &nbsp;<SortIcon />&nbsp;</div>)
        } else {
            return (<div onClick={() => toggleSort(_key)} className="ui-col-sort active">{_text} &nbsp;<SortIcon />&nbsp;</div>)
        }
    }

    const columns = [
        {
            stock: true, title_link: true, min: true, key: "in_store_rank", title: <>Rank</>, width: 100
        },
        {
            stock: true, title_link: true, min: true, key: "available_on_hand", title: <>aOH</>, width: 35, render: (e, f) => {
                if (istl(f)) { return <div style={{ "textAlign": "center" }}>-</div>; } return (e) ? e : "";
            }
        },
        {
            stock: true, title_link: true, min: true, key: "available_on_order", title: <>aOO</>, width: 35, render: (e, f) => {
                if (istl(f)) { return <div style={{ "textAlign": "center" }}>-</div>; } return (e) ? e : "";
            }
        },
        {
            stock: true, title_link: true, min: true, key: "price", title: <>Price</>, width: 60, render: (e, f) => {
                return (istl(f)) ? drawPrice(f?.title_link?.price, true) : drawPrice(e, true);
            }
        },
        {
            stock: true, title_link: true, min: true, key: "binding", align: "left", title: <>Ed</>, width: 35, render: (e, f) => {
                return (istl(f)) ? f?.title_link?.binding : e;
            }
        },
        {
            stock: true, title_link: true, min: true, key: "title", align: "left", title: colSort("Title", "title", "title"), width: 160, render: (e, f) => {
                return (istl(f)) ? f?.title_link?.title : e;
            }
        },
        {
            stock: true, title_link: true, min: false, key: "author", align: "left", title: colSort("Author", "author", "author"), width: 110, render: (e, f) => {
                return (istl(f)) ? f?.title_link?.author : e;
            }
        },
        {
            stock: true, title_link: false, min: false, key: "supplier_1", align: "left", title: colSort("Supl", "supplier", "supplier_1"), width: 55, render: (e, f) => {
                return (istl(f)) ? "---" : e;
            }
        },
        {
            stock: false, title_link: true, min: false, key: "publication_date", align: "left", title: colSort("Pubdate", "publication_date"), width: 85, render: (e, f) => {
                return bm_date(f?.title_link?.publication_date);
            }
        },
        {
            stock: false, title_link: true, min: false, key: "rank", align: "left", title: colSort("Rank", "rank"), width: 73, render: (e, f) => {
                return f?.title_link?.rank
            }
        },
        {
            stock: true, title_link: false, min: false, key: "class", align: "left", title: colSort("Class", "class", "category_1"), width: 80, render: (e, f) => {
                return (istl(f)) ? <span style={{ fontFamily: "monospace" }}>{f?.category_1}</span> : <span style={{ fontFamily: "monospace" }}>{f?.category_1}</span>;
            }
        },
        {
            stock: true, title_link: false, min: false, key: "subclass", align: "left", title: "Subclass", width: 80, render: (e, f) => {
                return (istl(f)) ? <span style={{ fontFamily: "monospace" }}>{f?.category_2}</span> : <span style={{ fontFamily: "monospace" }}>{f?.category_2}</span>;
            }
        },
        {
            stock: true, title_link: true, min: false, key: "primary_code", align: "left", title: colSort("ISBN", "isbn", "primary_code"), width: 162, render: (e, f) => {
                return (istl(f)) ? f.title_link.primary_code : e + "" + f.condition_code;

            }
        },

        {
            stock: true, title_link: true, min: false, key: "cost", align: "left", title: "Cost", width: 70, render: (e) => drawPrice(e, true)
        },
        {
            stock: true, title_link: true, min: false, key: "sell_price", align: "left", title: "SellPr", width: 70, render: (e) => drawPrice(e, true)
        },

        {
            stock: true, title_link: true, min: false, key: "publication_date", align: "left", title: "PubDate", width: 80, render: (e) => bm_date(e)
        },

         {
            stock: true, title_link: true, min: false, key: "receive_date", align: "left", title: "1stRcvd", width: 80, render: (e) => bm_date(e)
        },

        {
            stock: true, title_link: true, min: false, key: "carton_quantity", align: "left", title: "Ctn", width: 40
        },

        {
            stock: true, title_link: true, min: false, key: "original_publisher", align: "left", title: "Publisher", width: 80
        },

          {
            stock: true, title_link: true, min: false, key: "section", align: "left", title: "Section", width: 60
        },
        



    ]


    const next = (_rows = 1) => {
        if (data.length === 0) { setSelected({}); return; }
        setAlign("auto");

        const nextIndex = data.findIndex(item => item?.stock_id === selected?.stock_id) + _rows;
        if (data.length <= nextIndex) {
            setSelected(data[data.length - 1]);
        }
        // Fetch chunk...

        if (nextIndex > data.length - buffer) {
            if (!loading) {
                fetchNext(true);
            }
        }

        if (nextIndex < data.length) {
            setSelected(data[nextIndex]);
        }
    };
    const prev = (_rows = 1) => {
        if (data.length === 0) { setSelected({}); return; }
        const prevIndex = data.findIndex(item => item?.stock_id === selected?.stock_id) - _rows;


        if (prevIndex < 2) {
            if (!loading) {
                fetchPrev(true);
            }
        }

        if (prevIndex < 0) {
            setSelected(data[0]);
            return;
        }
        if (prevIndex >= 0) {
            setSelected(data[prevIndex]);
        }
    };

    const fetchNext = () => {

        if (loading || !filters.dynamic) {
            if (filters?.type === "keyword") {
                setLoading(true);
                const event = new CustomEvent("callKeywordNext", { detail: data });
                window.dispatchEvent(event);
                setTimeout(() => {
                    setLoading(false)
                }, 100)
            }
            return;
        }
        setLoading(true);

        pubCall("stock.getNext", { ...filters, "limit": 20, "stock_id": data[data.length - 1]?.stock_id }, (_s, _r) => {
            if (_s) {
                setData([...data.concat(_r)]);
            } else {
                showError(_r);
            }
            setLoading(false);
        })
    }


    const fetchPrev = () => {
        if (loading || !filters.dynamic) { return }
        setLoading(true);
        pubCall("stock.getPrevious", { ...filters, "limit": 20, "stock_id": data[0]?.stock_id }, (_s, _r) => {
            if (_s) {
                setAlign("start");
                setData([..._r.concat([...data])]);
            } else {
                showError(_r);
            }
            setLoading(false);
        })
    }

    const fetch = () => {
        if (loading || !filters.dynamic) { return }
        setLoading(true);
        let _filters = { ...filters };
        if (selected?.stock_id) {
            _filters.stock_id = selected.stock_id;
        } else {
            if (Cookies.get("inventory_stock_id")) {
                _filters.stock_id = Cookies.get("inventory_stock_id");
            }
        }

        // Don't search empty titlelink stock_id (prefix with no-stock)
        if (_filters.stock_id && _filters.stock_id.includes("no-stock")) {
            delete _filters.stock_id;
        }




        pubCall("stock.getInitial", _filters, (_s, _r) => {

           
            if(block){
                return;
                setBlock(false);
            }


            if (_s) {
                if (_r.rows_previous.length > 0) {
                    setAlign("start");
                }
                setData(_r.rows_previous.concat(_r.rows_next));

                setSelected((_r.rows_next.length > 0) ? _r.rows_next[0] : {})
            } else {
                showError(_r);
            }
            setLoading(false);
        })
    }

    useEffect(fetch, [filters]);


    useEffect(() => {

        let _p = (isTitleLink) ? "Title Link" : "Inventory"
        if (!filters.dynamic) {
            let _i = data.findIndex(item => item.stock_id == selected.stock_id) + 1;
            let _t = data.length;
            signal.value = { ...signal.value, "title": _p + " " + _i + "/" + _t }
        } else {
            signal.value = { ...signal.value, "title": _p }
        }

    }, [selected, filters])

    const getColumns = () => {
        if (isTitleLink) {
            return (min) ? columns.filter(item => item.min && item.title_link) : columns.filter(item => item.title_link)
        } else {
            return (min) ? columns.filter(item => item.min && item.stock) : columns.filter(item => item.stock)
        }
    }

    return (
        <>
            <ScrollWrap ref={scrollRef} reset={state?.view} width={1200}>
                <VirtualTable
                    controller={controller}
                    columns_editable={false}
                    medium={true}
                    header={header}
                    className={(view === "inventory" || view === "inventory_full") ? "" : "desaturate"}
                    onWheel={(e) => (e.deltaY > 0) ? next() : prev()}
                    onRowClick={(item, event, index) => { setAlign("auto"); setSelected(item) }}
                    next={next}
                    prev={prev}
                    scrollbar={true}
                    scrollindicator={true}
                    infinite={infinite}
                    align={align}
                    row_key={"stock_id"}
                    onLoadMore={(_start, _end, _prepend) => {
                        if (_prepend) {
                            if (data?.length > 0 && data[0]?.number !== 1) {
                                fetchPrev()
                            }
                        } else {
                            if (data?.length > 0) {
                                fetchNext();
                            }

                        }
                    }}
                    current={selected}
                    data={filterLocal(data)}
                    columns={getColumns()}
                    width={(min) ? 398 : 1420}
                    fullWidth={true}
                    loading={loading}
                    offset={449}
                    height={202}
                    route={route}
                />
            </ScrollWrap>
        </>
    )
}